var e = {};

function t() {
  return e;
}

function n(t, r) {
  if (void 0 === r && (r = !1), Array.isArray(t)) {
    var i = t[1];
    return n(t[0]) + " and " + n(i, !0);
  }

  var a = e[t];
  if (void 0 === a) throw new Error('"' + t + '" does not seem to be a breakpoint name');

  if (r) {
    var o = parseFloat(a, 10),
        u = a.replace(o, "");
    return "(max-width: " + (o - ("em" === u ? .0635 : 1)) + u + ")";
  }

  return "(min-width: " + a + ")";
}

function r(e, t) {
  return void 0 === t && (t = !1), window.matchMedia(n(e, t)).matches;
}

function i(e, t) {
  var r = null,
      i = e.immediate,
      a = {
    name: e.name,
    useMax: e.useMax || !1,
    immediate: void 0 === i || i
  };

  function o() {
    r = "string" == typeof e || Array.isArray(e) ? window.matchMedia(n(e)) : window.matchMedia(n(a.name, a.useMax)), a.immediate && t(r), r.addEventListener("change", t);
  }

  return o(), {
    on: o,
    off: function off() {
      r && (r.removeListener(t), r = null);
    }
  };
}

function a(t, n) {
  void 0 === n && (n = {});
  var a = Object.keys(e),
      o = [],
      u = a;

  if (0 !== a.length) {
    var c = n.immediate,
        s = n.listenTo,
        f = {
      useMax: n.useMax || !1,
      immediate: void 0 === c || c
    };
    s && (u = s.sort(function (t, n) {
      return parseInt(e[t], 10) - parseInt(e[n], 10);
    }));

    var d = function d() {
      t(function (e, t) {
        void 0 === t && (t = !1);
        var n = [];
        return e.forEach(function (e) {
          r(e, t) && n.push(e);
        }), t ? n : n.reverse();
      }(u, f.useMax));
    };

    return m(), {
      on: m,
      off: function off() {
        o.length && (o.forEach(function (e) {
          return e.off();
        }), o = []);
      }
    };
  }

  function m() {
    u.forEach(function (e) {
      var t = i({
        name: e,
        useMax: f.useMax,
        immediate: !1
      }, d);
      o.push(t);
    }), f.immediate && d();
  }
}

export default function (o) {
  var u;
  if (void 0 === o && (o = {}), "string" == typeof o && "meta" === o ? e = function () {
    var e = document.createElement("meta");
    e.classList.add("breakpoint-helper"), document.getElementsByTagName("head")[0].appendChild(e);
    var t = window.getComputedStyle(e).getPropertyValue("font-family");
    return t.length <= 0 ? {} : (t = t.replace(/'|"/g, "").split("&")).reduce(function (e, t) {
      var n = t.split("=");
      return e[n[0]] = n[1], e;
    }, {});
  }() : "string" == typeof o && "custom" === o ? (u = [].concat(document.styleSheets).filter(function (e) {
    return -1 !== e.href.indexOf(window.location.origin);
  }), e = [].concat(u).reduce(function (e, t) {
    return [].concat(t.cssRules).forEach(function (t) {
      ":root" === t.selectorText && t.cssText.split("{")[1].replace("}", "").split(";").forEach(function (t) {
        var n = t.split(":"),
            r = n[0],
            i = n[1];
        -1 !== r.indexOf("--bph-") && (e[r.replace("--bph-", "").trim()] = i.trim());
      });
    }), e;
  }, {})) : e = o, 0 === Object.keys(e).length) throw new Error("No breakpoints defined");
  return {
    getBreakpoints: t,
    getMediaQuery: n,
    isMatching: r,
    listen: i,
    listenAll: a
  };
}